import React, { Component } from "react";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";
import { formatNumber } from "../../utils/formatting";

/**
 * Objectives — Master data สำหรับใช้ใน Sales Visit Planning
 * โครงสร้างตามหน้า CRUD อื่นในโปรเจกต์ (เช่น departments) เชื่อมต่อ API: admin/objectives
 */
export default class Objectives extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",

      page: 1,
      page_size: 10,
      count: 0,
      data: [],

      modal_create: false,
      modal_update: false,

      // Form States
      uid: "",
      company_id: company?.id,
      code: "",
      name: "",
      is_active: "Active",
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search, page_size } = this.state;
    loading(true);

    let [result] = await Promise.all([
      GET("admin/objectives", {
        page_size,
        page,
        data_search: filter_search || "",
        uid: "",
      }),
    ]);

    if (result?.status) {
      this.setState({
        data: result.data || [],
        count: result.pagination?.count || 0,
        page,
      });
    }

    loading(false);
  };

  CreateUpdate = async () => {
    const { uid, company_id, code, name, is_active } = this.state;

    if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_objective_name"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);
      let body = {
        company_id,
        code,
        name,
        is_active: is_active === "Active",
      };

      let result = !uid
        ? await POST("admin/objectives", body)
        : await PUT("admin/objectives/" + uid, body);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  Delete = async (uid) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      let result = await DELETE("admin/objectives/" + uid, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  openCreate = () =>
    this.setState({
      modal_create: true,
      modal_update: false,
      uid: "",
      code: "",
      name: "",
      is_active: "Active",
    });

  openEdit = (item) =>
    this.setState({
      modal_create: false,
      modal_update: true,
      uid: item.uid,
      code: item.code || "",
      name: item.name || "",
      is_active: item.is_active ? "Active" : "Inactive",
    });

  render() {
    const { data, count, page, page_size, filter_search, modal_create, modal_update, code, name, is_active } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          {/* Header */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("objectives")}</h3>
              <div className="text-secondary text-14">{t("objectives_desc")}</div>
            </div>
          </div>

          {/* Filter Toolbar */}
          <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <div className="d-flex flex-wrap gap-2 flex-grow-1">
                <div className="position-relative">
                  <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{""}</span>
                  <input
                    type="text"
                    className="form-control ps-5 wpx-350"
                    style={{ height: "38px" }}
                    placeholder={t("search_objectives")}
                    value={filter_search}
                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                  />
                </div>
                <div className="d-flex gap-2">
                  <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                    {t("filter")}
                  </button>
                  <button
                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                    onClick={() => this.setState({ filter_search: "" }, () => this.Get(1))}
                  >
                    {t("clear_all")}
                  </button>
                </div>
              </div>
              {can("objective.create") ? (
              <button
                className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                onClick={this.openCreate}
              >
                <span className="me-2 text-16">+</span> {t("add_objective")}
              </button>
              ) : null}
            </div>
          </div>

          {/* Table */}
          <div className="bg-white rounded-4 shadow-sm overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "800px" }}>
                <thead>
                  <tr className="text-dark fw-bold text-12 border-bottom border-light">
                    <th className="py-3 px-3 border-0 wpx-250">{t("objective_code")}</th>
                    <th className="py-3 px-3 border-0">{t("objective_name")}</th>
                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("status")}</th>
                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("actions")}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan={4} className="text-center text-secondary py-5">-</td>
                    </tr>
                  ) : (
                    data.map((item, idx) => (
                      <tr key={item.uid || idx} className="border-bottom border-light bg-white">
                        <td className="px-3">
                          <div className="text-secondary text-14">{item.code || "-"}</div>
                        </td>
                        <td className="px-3">
                          <div className="text-dark text-14">{item.name || "-"}</div>
                        </td>
                        <td className="text-center">
                          {item.is_active ? (
                            <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                          ) : (
                            <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                          )}
                        </td>
                        <td className="text-center">
                          <div className="d-flex align-items-center gap-2 justify-content-center">
                            <ActionIconButton label={can("objective.update") ? t("edit") : t("view")} icon={can("objective.update") ? ACTION_ICONS.edit : ACTION_ICONS.view} variant={can("objective.update") ? "warning" : "primary"} onClick={() => this.openEdit(item)} />
                            {can("objective.delete") ? (
                            <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.Delete(item.uid)} />
                            ) : null}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Footer Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12 gap-2">
            <div>
              {t("showing")} {count === 0 ? 0 : formatNumber((page - 1) * page_size + 1)}-{formatNumber((page - 1) * page_size + data.length)} {t("of")} {formatNumber(count)} {t("objectives_count")}
            </div>
            <Pagination
              className="mb-0"
              count={Math.ceil(count / page_size) || 1}
              page={page}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, p) => this.Get(p)}
            />
          </div>
        </div>

        {/* MODAL: CREATE / EDIT */}
        <Modal
          show={modal_create || modal_update}
          onHide={() => this.setState({ modal_create: false, modal_update: false })}
          centered
          contentClassName="border-0 rounded-4 shadow-lg"
        >
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
            <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit") : t("add_objective")}</h5>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
<fieldset disabled={this.state.modal_update && !can("objective.update")} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
            <div className="row g-3">
              <div className="col-md-5">
                <label className="form-label text-14 text-dark mb-2">{t("objective_code")}</label>
                <input
                  type="text"
                  className="form-control py-2"
                  value={code}
                  onChange={(e) => this.setState({ code: e.target.value })}
                />
              </div>
              <div className="col-md-7">
                <label className="form-label text-14 text-dark mb-2">
                  {t("objective_name")} <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control py-2"
                  value={name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                />
              </div>

              {/* Status */}
              <div className="col-12 mt-3 border-top pt-3">
                <h6 className="fw-bold mb-3 d-flex align-items-center">
                  <span className="icon text-primary me-2">{""}</span> {t("status")}
                </h6>
                <div className="d-flex gap-4">
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input mt-0 pointer"
                      type="radio"
                      name="objStatus"
                      id="objActive"
                      checked={is_active === "Active"}
                      onChange={() => this.setState({ is_active: "Active" })}
                    />
                    <label className="form-check-label text-dark text-14 pointer" htmlFor="objActive">{t("active")}</label>
                  </div>
                  <div className="form-check d-flex align-items-center gap-2">
                    <input
                      className="form-check-input mt-0 pointer"
                      type="radio"
                      name="objStatus"
                      id="objInactive"
                      checked={is_active === "Inactive"}
                      onChange={() => this.setState({ is_active: "Inactive" })}
                    />
                    <label className="form-check-label text-dark text-14 pointer" htmlFor="objInactive">{t("inactive")}</label>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
</Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ modal_create: false, modal_update: false })}
            >
              {t("cancel")}
            </button>
            {(!this.state.modal_update || can("objective.update")) ? <button
              className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
              onClick={this.CreateUpdate}
            >
              <span className="icon me-2">{""}</span> {t("save")}
            </button> : null}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
